import(/* webpackMode: "eager" */ "/var/www/duncantaylor/duncantaylor-new-website/duncan-taylor/src/app/page.tsx")